export default __webpack_public_path__ + "static/media/i059jk.005de696.webp";